import React from 'react';

import { Badge, BadgeProps } from '@mantine/core';
import { StripeConnectAccount } from 'types';

const statusColorMap: Record<StripeConnectAccount['status'], BadgeProps['color']> = {
  Onboard: 'gray',
  Enabled: 'kiloBlue',
  Complete: 'green',
  'Restricted soon': 'yellow',
  Restricted: 'red',
  Rejected: 'red',
};

const ConnectAccountStatusBadge = ({ status }: { status: StripeConnectAccount['status'] }): JSX.Element => {
  return (
    <Badge color={statusColorMap[status]} variant='filled' size='md' radius='md'>
      {status}
    </Badge>
  );
};

export default ConnectAccountStatusBadge;
